<template>
  <div>
    <!-- Alertas de estado -->
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="alert alert-info" v-if="solicitud.estado === 'RECIBIDA'">
          <i class="fa fa-info-circle me-2"></i>
          <strong>Recepción conforme registrada</strong> - La recepción de bienes/servicios ha sido registrada exitosamente.
          Proceda a generar el informe de conclusión y cerrar el proceso de contratación.
        </div>
        <div class="alert alert-warning" v-else-if="solicitud.estado === 'CONTRATADA'">
          <i class="fa fa-exclamation-triangle me-2"></i>
          <strong>Pendiente de recepción</strong> - Antes de concluir el proceso, debe registrar la recepción de bienes/servicios en la pestaña "Recepción".
        </div>
        <div class="alert alert-success" v-else-if="solicitud.estado === 'CONCLUIDA'">
          <i class="fa fa-check-circle me-2"></i>
          <strong>¡Proceso concluido exitosamente!</strong> - La contratación ha finalizado según lo establecido en el Manual de Procedimientos.
        </div>
      </div>
    </div>

    <!-- Formulario de conclusión (solo cuando está RECIBIDA) -->
    <div class="row" v-if="solicitud.estado === 'PAGADO'">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="fa fa-flag-checkered me-2"></i>Informe de Conclusión del Proceso</h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="concluirProceso">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label">Fecha de Cierre *</label>
                    <input 
                      v-model="conclusion.fecha_cierre" 
                      type="date" 
                      class="form-control" 
                      :class="{ 'is-invalid': errors.fecha_cierre }"
                      required
                    >
                    <div class="invalid-feedback" v-if="errors.fecha_cierre">{{ errors.fecha_cierre[0] }}</div>
                  </div>
                </div>
                <!--
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label">Responsable del Cierre</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      :value="usuarioActual" 
                      disabled
                    >
                  </div>
                </div>
                -->
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <label class="form-label">Observaciones Finales</label>
                    <textarea 
                      v-model="conclusion.observaciones" 
                      class="form-control" 
                      rows="3"
                      placeholder="Registre observaciones finales sobre el proceso de contratación (opcional)"
                    ></textarea>
                  </div>
                </div>
                <!--
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <label class="form-label">Informe de Conclusión (PDF) *</label>
                    <input 
                      type="file" 
                      @change="handleFileUpload" 
                      class="form-control" 
                      :class="{ 'is-invalid': errors.archivo }"
                      accept=".pdf"
                      required
                    >
                    <small class="text-muted">Formato PDF, tamaño máximo 10MB</small>
                    <div class="invalid-feedback" v-if="errors.archivo">{{ errors.archivo[0] }}</div>
                  </div>
                </div>
                -->
              </div>
              
              <div class="mt-3">
                <BButton 
                  type="submit" 
                  variant="success" 
                  :disabled="loading"
                  class="me-2"
                >
                  <i v-if="loading" class="fa fa-spinner fa-spin me-1"></i>
                  <i v-else class="fa fa-flag-checkered me-1"></i>
                  {{ loading ? 'Procesando...' : 'Concluir Proceso de Contratación' }}
                </BButton>
                <!--
                <BButton 
                  type="button" 
                  variant="secondary" 
                  @click="resetForm"
                >
                  <i class="fa fa-undo me-1"></i> Limpiar
                </BButton>
                -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Mostrar informe de conclusión existente -->
    <div class="row mt-3" v-if="informeExistente">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="fa fa-file-pdf-o me-2 text-danger"></i>Informe de Conclusión Registrado</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-success">
                  <i class="fa fa-check-circle me-2"></i>
                  <strong>Proceso concluido el {{ formatDate(informeExistente.fecha_cierre) }}</strong>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <table class="table table-sm table-borderless">
                  <tr>
                    <td width="35%"><strong>Código Solicitud:</strong></td>
                    <td>{{ solicitud.codigo }}</td>
                  </tr>
                  <tr>
                    <td><strong>Fecha Cierre:</strong></td>
                    <td>{{ formatDate(informeExistente.fecha_cierre) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Registrado por:</strong></td>
                    <td>{{ informeExistente.usuario_registro }}</td>
                  </tr>
                  <tr>
                    <td><strong>Fecha Registro:</strong></td>
                    <td>{{ formatDateTime(informeExistente.fecha_registro) }}</td>
                  </tr>
                  <tr v-if="informeExistente.observaciones">
                    <td><strong>Observaciones:</strong></td>
                    <td>{{ informeExistente.observaciones }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6 text-center">
                <div class="border rounded p-3 bg-light">
                  <i class="fa fa-file-pdf-o fa-4x text-danger mb-2"></i>
                  <br>
                  <!-- Botón para generar PDF del Informe de Conclusión -->
                  <BButton 
                    v-if="informeExistente"
                    variant="danger" 
                    size="sm"
                    @click="generarPdfConclusion"
                    :disabled="generandoPdf"
                    title="Generar Informe de Conclusión"
                  >
                    <i v-if="generandoPdf" class="fa fa-spinner fa-spin"></i>
                    <i v-else class="fa fa-file-pdf"></i> 
                    Informe de Conclusión
                  </BButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumen ejecutivo del proceso -->
    <div class="row mt-3" v-if="solicitud.estado === 'CONCLUIDA' || informeExistente">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-success text-white">
            <h6 class="mb-0"><i class="fa fa-bar-chart me-2"></i>Resumen Ejecutivo del Proceso</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 text-center">
                <div class="border rounded p-3">
                  <h4 class="text-primary mb-0">{{ resumen.tiempo_total }} días</h4>
                  <small class="text-muted">Tiempo total del proceso</small>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="border rounded p-3">
                  <h4 class="text-success mb-0">Bs. {{ formatNumber(resumen.monto_final) }}</h4>
                  <small class="text-muted">Monto adjudicado</small>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="border rounded p-3">
                  <h4 class="text-info mb-0">{{ resumen.cantidad_etapas }}</h4>
                  <small class="text-muted">Etapas completadas</small>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="border rounded p-3">
                  <h4 class="text-warning mb-0">{{ resumen.cantidad_etapas }}</h4>
                  <small class="text-muted">Documentos generados</small>
                </div>
              </div>
            </div>
            
            <hr>
            <!--
            <div class="row mt-3">
              <div class="col-md-12">
                <h6>Línea de tiempo del proceso:</h6>
                <div class="timeline-wrapper mt-3">
                  <div 
                    v-for="(item, index) in resumen.linea_tiempo" 
                    :key="index"
                    class="timeline-item"
                  >
                    <div class="timeline-badge" :class="item.completada ? 'bg-success' : 'bg-secondary'">
                      <i :class="item.icono"></i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <h6 class="timeline-title">{{ item.etapa }}</h6>
                        <p class="text-muted small">
                          <i class="fa fa-calendar me-1"></i>{{ item.fecha || 'Pendiente' }}
                          <span v-if="item.usuario" class="ms-2">
                            <i class="fa fa-user me-1"></i>{{ item.usuario }}
                          </span>
                        </p>
                      </div>
                      <div class="timeline-body" v-if="item.detalle">
                        {{ item.detalle }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de confirmación de cierre -->
    <BModal v-model="modalConfirmacionVisible" title="Confirmar Cierre del Proceso" size="lg" centered hide-footer>
      <div class="text-center">
        <i class="fa fa-exclamation-triangle fa-4x text-warning mb-3"></i>
        <h5>¿Está seguro de concluir este proceso de contratación?</h5>
        <p class="text-muted">Una vez concluido, el proceso no podrá ser modificado y quedará registrado en el archivo definitivo.</p>
        
        <div class="alert alert-info text-start mt-3">
          <strong><i class="fa fa-info-circle me-2"></i>Verifique antes de continuar:</strong>
          <ul class="mb-0 mt-2">
            <li>✓ Todos los bienes/servicios han sido recibidos conforme</li>
            <li>✓ El pago al proveedor ha sido procesado</li>
            <li>✓ La documentación está completa en el expediente</li>
            <li>✓ No existen observaciones pendientes</li>
          </ul>
        </div>
        
        <div class="mt-3">
          <BButton variant="secondary" @click="modalConfirmacionVisible = false" class="me-2">
            Cancelar
          </BButton>
          <BButton variant="success" @click="confirmarCierre" :disabled="loadingConfirmacion">
            <i v-if="loadingConfirmacion" class="fa fa-spinner fa-spin me-1"></i>
            <i v-else class="fa fa-check-circle me-1"></i>
            Sí, concluir proceso
          </BButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BModal } from 'bootstrap-vue-3';
import { useAuthStore } from '@/stores/authStore';

const props = defineProps({ 
  solicitud: { type: Object, required: true },
  solicitudId: { type: Number, required: true }
});
const emit = defineEmits(['refresh']);

const authStore = useAuthStore();
const loading = ref(false);
const loadingConfirmacion = ref(false);
const modalConfirmacionVisible = ref(false);
const archivoSeleccionado = ref(null);
const generandoPdf = ref(false);
const errors = ref({});

// Datos del formulario
const conclusion = ref({
  fecha_cierre: new Date().toISOString().split('T')[0],
  observaciones: ''
});

const informeExistente = ref(null);

// Usuario actual
const usuarioActual = computed(() => {
  const user = authStore.user;
  return user ? `${user.nombres || ''} ${user.paterno || ''}`.trim() || user.username || 'Usuario' : 'Usuario actual';
});

// Calcular resumen del proceso
const resumen = computed(() => {
  const fechaInicio = props.solicitud.fecha_registro ? new Date(props.solicitud.fecha_registro) : null;
  const fechaCierre = informeExistente.value?.fecha_cierre ? new Date(informeExistente.value.fecha_cierre) : null;
  
  let tiempoTotal = 0;
  if (fechaInicio && fechaCierre) {
    const diffTime = Math.abs(fechaCierre - fechaInicio);
    tiempoTotal = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  // Construir línea de tiempo
  const lineaTiempo = [
    { etapa: 'Creación de Solicitud', completada: true, icono: 'fa fa-file-text', fecha: formatDate(props.solicitud.fecha_registro), usuario: props.solicitud.usuario_registro },
    { etapa: 'Autorización RPA', completada: props.solicitud.estado !== 'BORRADOR' && props.solicitud.estado !== 'RECHAZADA', icono: 'fa fa-check-circle', fecha: obtenerFechaEtapa('AUTORIZADA'), usuario: obtenerUsuarioEtapa('AUTORIZADA') },
    { etapa: 'Certificación POA/PAC', completada: props.solicitud.estado !== 'BORRADOR' && props.solicitud.estado !== 'RECHAZADA' && props.solicitud.estado !== 'AUTORIZADA', icono: 'fa fa-certificate', fecha: obtenerFechaEtapa('CERTIFICADA'), usuario: obtenerUsuarioEtapa('CERTIFICADA') },
    // { etapa: 'Selección de Proveedor', completada: props.solicitud.estado === 'EN_ADJUDICACION' || props.solicitud.estado === 'ADJUDICADA' || props.solicitud.estado === 'CONTRATADA' || props.solicitud.estado === 'RECIBIDA' || props.solicitud.estado === 'CONCLUIDA', icono: 'fa fa-search', fecha: obtenerFechaEtapa('EN_SELECCION') },
    { etapa: 'Adjudicación', completada: props.solicitud.estado !== 'BORRADOR' || props.solicitud.estado === 'CONTRATADA' || props.solicitud.estado === 'RECIBIDA' || props.solicitud.estado === 'CONCLUIDA', icono: 'fa fa-gavel', fecha: obtenerFechaEtapa('ADJUDICADA'), usuario: obtenerUsuarioEtapa('ADJUDICADA') },
    { etapa: 'Contrato/Orden', completada: props.solicitud.estado !== 'BORRADOR' || props.solicitud.estado === 'RECIBIDA' || props.solicitud.estado === 'CONCLUIDA', icono: 'fa fa-file-contract', fecha: obtenerFechaEtapa('CONTRATADA') },
    { etapa: 'Recepción', completada: props.solicitud.estado !== 'BORRADOR' || props.solicitud.estado === 'CONCLUIDA', icono: 'fa fa-clipboard-list', fecha: obtenerFechaEtapa('RECIBIDA'), usuario: obtenerUsuarioEtapa('RECIBIDA') },
    { etapa: 'Conclusión', completada: props.solicitud.estado === 'CONCLUIDA', icono: 'fa fa-flag-checkered', fecha: informeExistente.value?.fecha_cierre ? formatDate(informeExistente.value.fecha_cierre) : null, usuario: informeExistente.value?.usuario_registro }
  ];

  return {
    tiempo_total: tiempoTotal,
    monto_final: props.solicitud.adjudicacion?.monto_adjudicado || props.solicitud.monto_estimado,
    cantidad_etapas: lineaTiempo.filter(e => e.completada).length,
    cantidad_documentos: contarDocumentos(),
    linea_tiempo: lineaTiempo
  };
});

// Obtener fecha de una etapa específica desde la bitácora
const obtenerFechaEtapa = (estadoBuscado) => {
  if (!props.solicitud.bitacora) return null;
  const registro = props.solicitud.bitacora.find(b => b.accion === estadoBuscado);
  return registro ? formatDate(registro.fecha_registro) : null;
};

// Obtener usuario de una etapa específica desde la bitácora
const obtenerUsuarioEtapa = (estadoBuscado) => {
  if (!props.solicitud.bitacora) return null;
  const registro = props.solicitud.bitacora.find(b => b.accion === estadoBuscado);
  return registro ? registro.usuario_registro : null;
};

// Contar documentos generados
const contarDocumentos = () => {
  let count = 0;
  if (props.solicitud.documentos) count += props.solicitud.documentos.length;
  if (props.solicitud.contratos?.length) count += props.solicitud.contratos.length;
  if (props.solicitud.recepciones?.length) count += props.solicitud.recepciones.length;
  if (informeExistente.value) count++;
  return count;
};

// Obtener informe de conclusión existente
const fetchInformeConclusion = async () => {
  try {
    const response = await axios.get(`/informe-conclusion/${props.solicitud.id}`);
    if (response.data.data) {
      informeExistente.value = response.data.data;
    }
  } catch (error) {
    console.error('Error al cargar informe de conclusión:', error);
  }
};

// Subir archivo
const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (file && file.type !== 'application/pdf') {
    Swal.fire('Error', 'El archivo debe ser de tipo PDF', 'error');
    event.target.value = '';
    archivoSeleccionado.value = null;
    return;
  }
  if (file && file.size > 10 * 1024 * 1024) {
    Swal.fire('Error', 'El archivo no puede superar los 10MB', 'error');
    event.target.value = '';
    archivoSeleccionado.value = null;
    return;
  }
  archivoSeleccionado.value = file;
};

// Resetear formulario
const resetForm = () => {
  conclusion.value = {
    fecha_cierre: new Date().toISOString().split('T')[0],
    observaciones: ''
  };
  archivoSeleccionado.value = null;
  errors.value = {};
};

// Concluir proceso (abre modal de confirmación)
const concluirProceso = () => {
  if (!conclusion.value.fecha_cierre) {
    Swal.fire('Error', 'Debe ingresar la fecha de cierre', 'error');
    return;
  }
  /*
  if (!archivoSeleccionado.value) {
    Swal.fire('Error', 'Debe seleccionar el archivo del informe de conclusión', 'error');
    return;
  }
  */
  modalConfirmacionVisible.value = true;
};

// Confirmar cierre (enviar al servidor)
const confirmarCierre = async () => {
  loadingConfirmacion.value = true;
  
  try {
    const formData = new FormData();
    formData.append('id_solicitud', props.solicitud.id);
    formData.append('fecha_cierre', conclusion.value.fecha_cierre);
    formData.append('observaciones', conclusion.value.observaciones);
    formData.append('archivo', archivoSeleccionado.value);

    const response = await axios.post('/informe-conclusion/guardar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    
    Swal.fire({
      title: '¡Éxito!',
      text: response.data.message || 'Proceso de contratación concluido exitosamente',
      icon: 'success',
      confirmButtonText: 'Aceptar'
    });
    
    modalConfirmacionVisible.value = false;
    resetForm();
    await fetchInformeConclusion();
    emit('refresh');
    
  } catch (error) {
    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
      Swal.fire('Error', 'Verifique los datos ingresados', 'error');
    } else {
      Swal.fire('Error', error.response?.data?.message || 'Error al concluir el proceso', 'error');
    }
  } finally {
    loadingConfirmacion.value = false;
  }
};

/**
 * Generar PDF del Informe de Conclusión
 */
const generarPdfConclusion = async () => {
  generandoPdf.value = true;
  try {
    const response = await axios.get(`/informe-conclusion/pdf/${props.solicitud.id}`, {
      responseType: 'blob'
    });
    
    // Crear URL del blob y descargar
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    const nombreArchivo = `Informe_Conclusion_${props.solicitud.codigo}.pdf`;
    
    link.href = blobUrl;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
    
    Swal.fire('Éxito', 'Informe de Conclusión generado correctamente', 'success');
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', error.response?.data?.message || 'No se pudo generar el PDF', 'error');
  } finally {
    generandoPdf.value = false;
  }
};

// Formateadores
const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('es-BO');
};

const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString('es-BO');
};

const formatNumber = (number) => {
  if (!number) return '0.00';
  return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
};

// Inicialización
onMounted(() => {
  fetchInformeConclusion();
});
</script>

<style scoped>
.timeline-wrapper {
  position: relative;
  padding-left: 30px;
}

.timeline-item {
  position: relative;
  margin-bottom: 25px;
}

.timeline-badge {
  position: absolute;
  left: -30px;
  top: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  color: white;
}

.timeline-badge i {
  font-size: 18px;
  line-height: 40px;
}

.timeline-panel {
  margin-left: 20px;
  padding: 10px 15px;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
}

.timeline-panel::before {
  content: '';
  position: absolute;
  left: -9px;
  top: 12px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 8px 8px 0;
  border-color: transparent #e3e3e3 transparent transparent;
}

.timeline-title {
  margin: 0 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.bg-success {
  background-color: #28a745;
}

.bg-secondary {
  background-color: #6c757d;
}

.bg-warning {
  background-color: #ffc107;
}

.bg-primary {
  background-color: #007bff;
}
</style>